
import "../css/layout.css"

export default function Footer() {
  return (
    <div className='footer'>
      <br />
      All Images © YiJu Miller and may not be used without written permission <br />
      <a href="mailto:ymillerart@outlook.com?cc=yijumillerart@outlook.com">Send email</a>&nbsp;&nbsp;&nbsp;
      <a href="https://www.facebook.com/Yijumiller">Facebook</a>
    </div>
  )
}
